export const products = [
  {
    id: 1,
    name: 'Grand Besan Flour',
    description: 'Best choice for sweet & savouries. Naturally processed & hygienically packed.',
    category: 'Besan Flour',
    features: ['Naturally Processed', 'Hygienically Packed', 'Best for Sweet & Savouries'],
    variants: [
      {
        weight: '500g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768922721/6700007215aa2b0397b31ec3_sms_20jpg_kbbcsa.png',
        amazonUrl: 'https://www.amazon.in/dp/B0F247XN2L?ref=cm_sw_r_cso_cp_apin_dp_AHM14MYZ44XW16TTHWWE&ref_=cm_sw_r_cso_cp_apin_dp_AHM14MYZ44XW16TTHWWE&social_share=cm_sw_r_cso_cp_apin_dp_AHM14MYZ44XW16TTHWWE&previewDoh=1'
      },

      {
        weight: '30kg',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1769014247/4f43c881-77e7-4533-9d50-032703df39e5.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 2,
    name: 'Royal Besan Flour',
    description: 'Premium besan flour for sweet & savouries. Naturally processed with superior quality.',
    category: 'Besan Flour',
    features: ['Premium Quality', 'Natural Processing', 'Perfect Texture'],
    variants: [
      {
        weight: '500g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768922750/6700021a58fb2a673f008aac_royal_20png_20big_20size_oey0sp.png',
        amazonUrl: 'https://www.amazon.in/dp/B0F24583YK?ref=cm_sw_r_cso_wa_apin_dp_1S622P5DEDSNZAQ24P0M&ref_=cm_sw_r_cso_wa_apin_dp_1S622P5DEDSNZAQ24P0M&social_share=cm_sw_r_cso_wa_apin_dp_1S622P5DEDSNZAQ24P0M&previewDoh=1'
      },
      {
        weight: '30kg',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1769014495/67fd5e8a-0d65-4348-99be-3a17b1fac80c.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 3,
    name: 'Shakthi Besan Flour',
    description: 'Traditional besan flour crafted for authentic taste. Hygienically packed for freshness.',
    category: 'Besan Flour',
    features: ['Traditional Recipe', 'Authentic Taste', 'Long Freshness'],
    variants: [
      {
        weight: '500g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768922762/67000316f0630d3ab7729380_sakthi_20size_20large_drabtu.png',
        amazonUrl: 'https://www.amazon.in/dp/B0F245T6K2?ref=cm_sw_r_cso_wa_apin_dp_4JK7D124AHYJV1MXHFC5&ref_=cm_sw_r_cso_wa_apin_dp_4JK7D124AHYJV1MXHFC5&social_share=cm_sw_r_cso_wa_apin_dp_4JK7D124AHYJV1MXHFC5&previewDoh=1'
      },
      {
        weight: '30kg',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1769014584/7fcce8d8-cd16-473e-914f-ebb99284d5d5.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 4,
    name: 'Soy King',
    description: 'Textured soya protein chunks - perfect for healthy, protein-rich meals.',
    category: 'Soya Products',
    features: ['High Protein', 'Versatile Use', 'Nutritious'],
    variants: [
      {
        weight: '200g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1769014854/ed7a2aab-fc10-4d57-bafc-bf9e741e959e.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 5,
    name: 'Corn Flour',
    description: 'Hygienically packed corn flour for natural freshness. Perfect for various culinary uses.',
    category: 'Corn Flour',
    features: ['Natural Freshness', 'Hygienic Packing', 'Multi-purpose'],
    variants: [
      {
        weight: '1kg',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768922784/670003063ddaa6d2d8517337_sms_20cornflour_20size_20large_gu0fos.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 6,
    name: 'Rice Flour',
    description: 'Hygienically packed rice flour for natural freshness. Perfect for various culinary uses.',
    category: 'Rice Flour',
    features: ['Natural Freshness', 'Hygienic Packing', 'Multi-purpose'],
    variants: [
      {
        weight: '500g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768923078/rice_otf8g7.png',
        amazonUrl: '#'
      }
    ]
  },
  {
    id: 7,
    name: 'Ragi Flour',
    description: 'Hygienically packed ragi flour for natural freshness. Perfect for various culinary uses.',
    category: 'Ragi Flour',
    features: ['Natural Freshness', 'Hygienic Packing', 'Multi-purpose'],
    variants: [
      {
        weight: '500g',
        image: 'https://res.cloudinary.com/dytr7tpmt/image/upload/v1768923079/ragi_i4lcvo.png',
        amazonUrl: '#'
      }
    ]
  },
];